import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { TUserRole } from '@core/models/interfaces';

const roleGuard = (allowedRoles: TUserRole[]): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const role = authService.userRole();

    if (role && allowedRoles.includes(role)) {
      return true;
    }

    return router.parseUrl('/auth/login');
  }
};

export { roleGuard };
